var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"dataTable",attrs:{"fit":"fit","columns":_vm.columns,"rows":_vm.rows,"indexColumn":{ width: '40px', borderBottom: '1px solid #8da1b9 !important' },"excel":_vm.isButton_(_vm.scrId, 'EX')},on:{"changedPage":_vm.changedPage,"row-dblclick":_vm.dblClickRow}})
}
var staticRenderFns = []

export { render, staticRenderFns }